import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Icon } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';


const ScanNowModal = ({
  onClose,
}) => (
  <Modal open onClose={onClose} size="small">
    <DyzioModalHeader headerText="Scanning Now..." onClose={onClose} />
    <Modal.Content style={{ textAlign: 'center' }}>

      <h5>The system is scanning all channels now, It takes about 30 seconds!</h5>

      <div style={{ padding: 30 }}>
        <Icon size="massive" name="circle notched" loading color="blue" />
      </div>
      <h5>Thanks for your patience!</h5>
      <p>This window will close when the scan is complete.</p>
    </Modal.Content>
  </Modal>
);

ScanNowModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ScanNowModal;



/** WEBPACK FOOTER **
 ** ./src/components/scan-now-modal/index.js
 **/